"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoaderButton;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _Button = _interopRequireDefault(require("../Button"));

require("./LoaderButton.css");

require("font-awesome/css/font-awesome.min.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function LoaderButton(_ref) {
  var isLoading = _ref.isLoading,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = _objectWithoutProperties(_ref, ["isLoading", "disabled"]);

  var customClassName = props.customClassName || 'custom-button';
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    customClassName: "".concat(customClassName, " mt1rem"),
    disabled: disabled || isLoading,
    type: "success",
    clickHandler: props.clickHandler || null,
    text: isLoading ? /*#__PURE__*/_react["default"].createElement("i", {
      className: "fa fa-refresh spinning",
      "aria-hidden": "true"
    }) : props.children
  }, props));
}